// @flow

import * as React from 'react';
import numeral from 'numeral';
import glamorous, { Span } from 'glamorous';
import RewriteLink from 'app/components/routing/RewriteLink';
import Tappable from 'app/components/commons/Tappable';
import t from 'app/utils/translate';

type Props = {
  challengeId: string,
  className?: string,
  globalScore: number,
  match: string,
  onRef?: () => void,
  order: number,
};

const defaultProps = {
  className: undefined,
  onRef: undefined,
};

const Heading = glamorous.span(props => ({
  color: props.theme.color.white,
  fontWeight: props.theme.fontWeight.demiBold,
  paddingRight: 5,
}));

const Details = glamorous.div(props => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: props.theme.fontSize.tiny,
  fontWeight: props.theme.fontWeight.normal,
  color: props.theme.color.white,
  height: 30,
  width: '100%',
  textTransform: 'uppercase',
}));

const ConstrainedDiv = glamorous.div({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}, props => ({
  maxWidth: props.width,
}));

const FlexDiv = glamorous.div({
  display: 'flex',
  whiteSpace: 'nowrap',
  paddingLeft: 6,
  paddingRight: 6,
});

const OverflowFlexDiv = glamorous(FlexDiv)({
  overflow: 'hidden',
}, props => ({
  [props.theme.mediaQuery.desktopAndUp]: {
    minWidth: 250,
  },
}));

const LinkButton = glamorous(Tappable)({
  overflow: 'hidden',
  display: 'flex',
});

function LeaderboardRowDetails({
  challengeId,
  className,
  globalScore,
  match,
  onRef,
  order,
}: Props) {
  return (
    <Details innerRef={onRef} className={className}>
      <OverflowFlexDiv>
        <Span paddingRight={2}>{order}. </Span>
        <Heading>{t('Match')}:</Heading>
        <LinkButton
          component={RewriteLink}
          to={`/challenge/${challengeId}`}
        >
          <ConstrainedDiv width="100%">{match}</ConstrainedDiv>
          <Span paddingLeft={4} className="ion-android-open" />
        </LinkButton>
      </OverflowFlexDiv>
      <FlexDiv>
        <Heading>{t('Global Points')}:</Heading>
        {numeral(globalScore).format('0.00')}
      </FlexDiv>
    </Details>
  );
}

LeaderboardRowDetails.defaultProps = defaultProps;

export default LeaderboardRowDetails;
